import React, {useState, useEffect} from "react";
import './FilterDropdown.css';

import TypeTag from "../../tags/TypeTag";
import MedicTag from "../../tags/MedicTag";

const FilterDropdown = ({title, options, selected, updateSelected, multiple, dropdown}) => {
    const [isOpen, setIsOpen] = useState(false);

    // Convert options to array of entries whether it's a Map or object
    const getOptionsEntries = () => {
        if (options instanceof Map) {
            return Array.from(options.entries());
        }
        return Object.entries(options);
    };

    // Get option value for display
    const getOptionValue = (option) => {
        const entries = getOptionsEntries();
        const found = entries.find(([key]) => key === option);
        return found ? found[1] : option;
    };

    const handleOptionClick = (option) => {
        updateSelected((prevSelected) => {
            if (multiple) {
                return prevSelected.includes(option) 
                ? prevSelected.filter(item => item !== option) 
                : [...prevSelected, option];
            } else {
                return [option];
            }
        })
    }

    const selectAll = () => {
        const entries = getOptionsEntries();
        updateSelected(entries.map(([key]) => key));
    }

    const clearAll = () => {
        updateSelected([]);
    }

    useEffect(() => {
        console.log("Selected options:", selected);
    }, [selected]); // debug

    useEffect(() => {
        // when dropdown updates, set isOpen to dropdown
        if (dropdown != null) {
            console.log("Dropdown changed:", dropdown);
            setIsOpen(false);
        }
    }, [dropdown]);

    const entries = getOptionsEntries();

    return (
        <div className={"filter-dropdown " + title}>
            <button 
            className="select-btn"
            aria-label="select button"
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            aria-controls="select-dropdown"
            onClick={(e) => setIsOpen(!isOpen)}
            >
                <span className="title">{multiple ? title : getOptionValue(selected[0])}</span>
                <i className="fa-solid fa-angle-down"></i>
            </button>
            <ul className={isOpen ? "options-box open" : "options-box"} role="listbox">
                {entries.map(([key, value]) => (
                    <li 
                        key={key}
                        className="option" 
                        role="option" 
                        onClick={() => handleOptionClick(key)}
                    >
                        <input 
                            type={multiple ? "checkbox" : "radio"} 
                            id={key} 
                            checked={selected.includes(key)} 
                            readOnly
                        />
                        {title === "Type Tags" ? (
                            <TypeTag reportType={key} isButton={false} />
                        ) : title === "Medics" ? (
                            <MedicTag medicNumber={value || key} isButton={false} />
                        ) : (
                            <label htmlFor={key}>{value || key}</label>
                        )}
                    </li>
                ))}
                {multiple
                ? 
                <div className="select-ctrls">
                    <span onClick={() => selectAll()}>Select All</span>
                    <span onClick={() => clearAll()}>Clear</span>
                </div>
                :
                ""
                }
            </ul>
        </div>
    )
};

export default FilterDropdown;